import { create } from "zustand"
import { persist } from "zustand/middleware"

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      isLoading: true, // True until token validation completes

      login: (token, user) => {
        set({ token, user, isAuthenticated: true, isLoading: false })
      },

      logout: () => {
        set({ token: null, user: null, isAuthenticated: false, isLoading: false })
      },

      setUser: (user) => {
        set({ user })
      },

      setLoading: (isLoading) => {
        set({ isLoading })
      },

      setToken: (token) => {
        set({ token })
      },

      setAuthenticated: (isAuthenticated) => {
        set({ isAuthenticated })
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({ token: state.token }),
    }
  )
)

export const useUIStore = create((set) => ({
  sidebarOpen: true,
  commandPaletteOpen: false,
  theme: "dark",

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  
  toggleCommandPalette: () => set((state) => ({ commandPaletteOpen: !state.commandPaletteOpen })),
  setCommandPaletteOpen: (open) => set({ commandPaletteOpen: open }),
  
  setTheme: (theme) => {
    document.documentElement.classList.toggle("dark", theme === "dark")
    set({ theme })
  },
}))

export const useNotificationStore = create((set, get) => ({
  notifications: [],

  addNotification: (notification) => {
    const id = Date.now()
    set((state) => ({
      notifications: [...state.notifications, { ...notification, id }],
    }))
    setTimeout(() => {
      get().removeNotification(id)
    }, notification.duration || 5000)
  },

  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }))
  },

  clearNotifications: () => {
    set({ notifications: [] })
  },
}))

export const useDashboardStore = create((set) => ({
  stats: null,
  health: null,
  metrics: null,

  setStats: (stats) => set({ stats }),
  setHealth: (health) => set({ health }),
  setMetrics: (metrics) => set({ metrics }),
}))
